'use client';
import { useState } from 'react';

/**
 * Hook used by the cross sell toggle label/button to temporarily apply a
 * feedback css class (e.g. 'added-icon' / 'removed-icon').
 *
 * flash(className) applies the class then clears it after the timeout.
 */
export default function useButtonFeedbackFlash(timeout = 1000) {
  const [feedbackClass, setFeedbackClass] = useState(null);

  const flash = (className) => {
    setFeedbackClass(className);

    // Clear css class after timeout
    window.setTimeout(() => setFeedbackClass(null), timeout);
  };

  return { feedbackClass, flash };
}
